// @flow
import React, { Component } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import {
  SingleTextField,
  StyledTextField,
  StyledSelect,
  CancelButton,
  SubmitButton,
  SingleCheckBox
} from "imagus-components";
import ChipInput from "../../../global/components/ChipInput";
import {
  ErrosDisplay,
  setErrorMsg,
  checkPositiveInteger
} from "../../containers/ErrosDisplay";

import Grid from "@material-ui/core/Grid";

type CreateFacebaseFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  name: string,
  personLimit: string,
  online: boolean,
  newCompanyId: string,
  model: string
};

type CreateFacebaseFormPropsType = {
  onClose: Function,
  openSnackbar: Function,
  facebase?: { [key: string]: * },
  company: { [key: string]: * },
  companyList?: Array<*>,
  demoOnly: boolean,
  canChangeModel: boolean,
  modelList: Array<*>,
  createFacebase: Function,
  editFacebase: Function
};

const initialform: CreateFacebaseFormStatesType = {
  errors: {},
  loading: false,
  name: "",
  personLimit: "",
  online: false,
  newCompanyId: "",
  model: ""
};

class CreateFacebaseForm extends Component<
  CreateFacebaseFormPropsType,
  CreateFacebaseFormStatesType
> {
  constructor(props: CreateFacebaseFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = initialform;
  }

  componentDidMount() {
    let initials = { ...initialform };
    const facebase = this.props.facebase;
    if (facebase) {
      initials.name = facebase.name;
      initials.personLimit = facebase.personLimit;
      initials.online = facebase.online;
      initials.newCompanyId = this.props.company.uuid;
      initials.model = facebase.model;
    } else {
      if (this.props.demoOnly) {
        initials.personLimit = 50;
      }

      initials.model = this.props.modelList[0].value;
    }

    this.setState({ ...initials, errors: {} });
  }

  handleTextChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState(
      {
        [name]: value
      },
      (): * => {
        if (name === "personLimit") {
          this.setState({
            errors: checkPositiveInteger(this.state.errors, value)
          });
        }
      }
    );
  };

  handleCheckBoxChange = (
    e: Event & { currentTarget: HTMLInputElement }
  ): * => {
    this.setState({
      [e.currentTarget.name]: !this.state[e.currentTarget.name]
    });
  };

  syncChange = (name: string, value: *) => {
    this.setState({
      [name]: value
    });
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState((): * => ({ loading: true }));
    if (this.props.facebase) {
      this.props.editFacebase(
        this.state.name.trim(),
        this.state.personLimit,
        this.state.online,
        this.state.newCompanyId,
        this.state.model,
        this.submitDone,
        this.submitFail
      );
    } else {
      this.props.createFacebase(
        this.state.personLimit,
        this.state.online,
        this.state.name.trim(),
        this.state.model,
        this.submitDone,
        this.submitFail
      );
    }
  };

  submitDone = () => {
    this.props.onClose();
    this.props.openSnackbar && this.props.openSnackbar(0);
  };

  submitFail = (errors: ErrorsType) => {
    this.setState({ errors: errors, loading: false });
  };

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;

    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="System Name"
              name="name"
              value={this.state.name}
              onChange={this.handleTextChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="Number of Faces in database"
              name="personLimit"
              value={this.state.personLimit}
              onChange={this.handleTextChange}
              inpuType="number"
              isDisabled={this.props.demoOnly}
            />
          </Grid>
          <Grid item xs={12}>
            <SingleCheckBox
              name="online"
              value={this.state.online}
              onChange={this.handleCheckBoxChange}
              label="Enable Online Syncing (*additional charges may apply)"
            />
          </Grid>
          {this.props.canChangeModel && (
            <Grid item xs={12}>
              <StyledSelect
                value={this.state.model}
                onChange={this.handleTextChange}
                name="model"
                label="Model Version"
                isRequired={true}
                menus={this.props.modelList}
                isStyled
              />
            </Grid>
          )}
          {this.props.companyList && (
            <Grid item xs={12}>
              <ChipInput
                name="newCompanyId"
                label="Change Company (* it will also change ALL linked Licences and Users companyId)"
                isStyled
                placeholder="Select a company"
                tags={this.props.companyList}
                value={this.state.newCompanyId}
                syncChange={this.syncChange}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <ErrosDisplay errors={errors} form="create facebase" />
          </Grid>
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton
                loading={loading}
                disabled={Object.keys(errors).length > 0}
              />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default CreateFacebaseForm;
